module.exports = __webpack_public_path__ + "static/media/tipeee-logo.59941cd5.svg";